<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm04_cont"><a id="page_v"></a><strong>Contents</strong></h2>
<p class="indent2"><a class="nounder" href="#/xhtml/ch00_fm05_pre#ch00_fm05_pre"><em>Preface</em></a></p>
<p class="indent2"><a class="nounder" href="#/xhtml/ch00_fm07_intro#ch00_fm07_intro">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">1 Humble Beginnings</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 Once in a Lifetime: Jakes Receives His Big Break</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 Prophetic Sign and Wonder: Jakes’ Ministry Explodes</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 A Virtuoso, a Prodigy: Jakes’ Appeal in the Spiritual Marketplace</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 A Message of Prosperity</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 “Woman Art Thou Really Loosed?”</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 Businessman and a Minister</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 The New Black Church</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 American Phenomenon: Summary and Conclusion</span></p>
<p class="toc2"><span class="nounder" href="#/xhtml/ch10_bib#ch10_bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch11_index#ch11_index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch12_author#ch12_author" title="Link target outside of Sample"><em>About the Author</em></span> <a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_cont.vue?482b9436